import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6db001e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timetableSearchOverlay" }

import { useRouter } from 'vue-router';
import { TimetableSearch, utcDate } from '@components';
import process from 'process';
import { formatInTimeZone } from 'date-fns-tz';
import { parseISO } from 'date-fns';
import { useTimetableStore } from '@components/store';
import { useSharedState } from '../helpers/shareState';
import { timezone } from '../envVariables';
import { closeOverlay } from '../helpers/closeOverlayPanel';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableSearch',
  setup(__props) {

const router = useRouter();

const sharedState = useSharedState();
sharedState.getState('timetableStore');

const initialDate = utcDate(new Date()).toISOString();
const explorePageUrl = process.env.VUE_APP_EXPLORE_URL;

const timetableStore = useTimetableStore();

const handleRedirect = (
  originPortName,
  destinationPortName,
  outboundDate,
  routeCode,
) => {
  timetableStore.addSearchToRecent({
    from: originPortName,
    to: destinationPortName,
    fromDate: outboundDate,
    routeCode,
  });

  const url = `${process.env.VUE_APP_TIMETABLES_URL}/#${router.resolve({
    name: 'timetableResult',
    params: {
      from: originPortName,
      to: destinationPortName,
      departureDate: formatInTimeZone(parseISO(outboundDate), timezone, 'yyyy-MM-dd'),
    },
  }).fullPath}`;
  window.location.href = url;

  // close overlay after redirecting
  const timetableBtn = document.getElementById('globalTimetableSearchButton');
  const timetableBtnMobile = document.getElementById('globalTimetableSearchButtonMobile');
  const timetableOverlay = document.getElementById('timetableSearchAppOverlay');

  if (timetableOverlay) {
    closeOverlay(timetableOverlay);
  }

  if (timetableBtn) {
    closeOverlay(timetableBtn);
  }

  if (timetableBtnMobile) {
    closeOverlay(timetableBtnMobile);
  }

  // remove overlay and stop scroll from body
  document.querySelector('body')?.classList.remove('darkOverlay');
  document.querySelector('html')?.classList.remove('stopScroll');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Search timetables')), 1),
    _createVNode(_unref(TimetableSearch), {
      class: "timetable-search-overlay",
      "button-text": _ctx.$t('View timetables'),
      "from-input-label": _ctx.$t('From'),
      "to-input-label": _ctx.$t('To'),
      "from-placeholder": _ctx.$t('Timetable search placeholder'),
      "to-placeholder": _ctx.$t('Timetable search placeholder'),
      "today-text": _ctx.$t('Today'),
      "map-link": _unref(explorePageUrl),
      "datepicker-teleport-id": "#vueDatepicker",
      "initial-date": _unref(initialDate),
      onTimetableSearchClick: _cache[0] || (_cache[0] = (
        originPortName,
        destinationPortName,
        outboundDate,
        routeCode,
      ) => handleRedirect(
        originPortName,
        destinationPortName,
        outboundDate,
        routeCode ))
    }, null, 8, ["button-text", "from-input-label", "to-input-label", "from-placeholder", "to-placeholder", "today-text", "map-link", "initial-date"])
  ]))
}
}

})